import axios from 'axios';

export async function scanFile({
    userId,
    repoId,
    path,
    content,
}: {
    userId: string;
    repoId: string;
    path: string;
    content: string;
}) {
    const res = await axios.post<{success: true}>(
        `/embedding`,
        {
            repoId,
            content,
            path,
        },
        {
            params: {userId},
        }
    );

    return res.data;
}

export async function scanProjectTSXFiles({
    userId,
    repoId,
    files,
}: {
    userId: string;
    files: {content: string; path: string}[];
    repoId: string;
}) {
    const res = await axios.post<{success: true}>(
        `/embedding/gpt/bulk`,
        {files, repoId},
        {
            params: {userId},
        }
    );

    return res.data;
}
